<template>
  <Modal
    :show="show.revokeAccess"
    action-text="Revoke Access"
    :button-props="{ color: 'error' }"
    cancel-text="Cancel"
    @action="confirm"
    @close="close"
  >
    <template #title>
      Revoke Access
    </template>

    <template #content>
      Remove access for <strong>{{ userName || 'this user' }}</strong>?
      They will no longer be able to edit this job profile.
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import Modal from '@/components/shared/Modal.vue';

const { show, modalParams } = storeToRefs(useModals());
const { setModal } = useModals();

const { revokeAccess } = useCurrentJobProfile();

const userName = computed(() => modalParams.value.revokeAccess?.name ?? '');

const close = () => setModal({ field: 'revokeAccess', value: false });

const confirm = async () => {
  try {
    await revokeAccess(modalParams.value.revokeAccess?.ulid);
  } finally {
    close();
  }
};
</script>
